import { useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import {
  Post,
  RecommendedUsers,
  EditProfileModal,
  PageLoader,
  FollowModal,
  HomeSearch,
} from '../components';
import AppContext from '../context/AppContext';

import { pageAnimation } from '../animation';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import EditIcon from '@mui/icons-material/Edit';
import profileApi from '../api/profile';
import useApi from '../hooks/useApi';
import postApi from '../api/post';
import userApi from '../api/user';
import defPic from '../assets/images/bg.jpg';
import followApi from '../api/follow';
import unfollowApi from '../api/unfollow';

import LinkIcon from '@mui/icons-material/Link';
import TwitterIcon from '@mui/icons-material/Twitter';
import LocationOnIcon from '@mui/icons-material/LocationOn';
export default function Profile() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;
  const handle = pathname.split('/')[1];
  const getProfile = useApi(profileApi.getProfile);
  const getPosts = useApi(postApi.getPublications);
  const getFollowing = useApi(userApi.following);
  const getFollowers = useApi(userApi.followers);
  const doesFollow = useApi(userApi.doesFollow);
  const follow = useApi(followApi.follow);
  const unfollow = useApi(unfollowApi.unfollow);
  const [profileModal, setProfileModal] = useState(false);
  const [followersModal, setFollowersModal] = useState(false);
  const [followingModal, setFollowingModal] = useState(false);
  const [chooseModal, setChooseModal] = useState();

  const [activeTab, setActiveTab] = useState('Posts');
  const {
    currentAccount,
    theme,
    isLoggedIn,
    isMember,
    hasLoaded,
    accountDetails,
  } = useContext(AppContext);

  let userDetails = getProfile.data?.profiles?.items[0];
  console.log('USER DETAILS HERE OOO', getProfile.data?.profiles);
  const tabs = ['Posts'];
  const followHandler = () => {
    follow.request([
      {
        profile: `${userDetails?.id}`,
      },
    ]);
  };
  const unfollowHandler = () => {
    unfollow.request(`${userDetails?.id}`);
  };
  useEffect(() => {
    if (hasLoaded) {
      if (!isLoggedIn) {
        navigate('/connect');
      } else if (!isMember) {
        navigate('/create-profile');
      } else {
      }
    }
  }, [isMember, isLoggedIn, hasLoaded]);
  useEffect(() => {
    getProfile.request(handle);
  }, []);

  useEffect(() => {
    if (follow?.success) {
      alert('User followed');
      window.location.reload();
    } else if (unfollow?.success) {
      alert('User unfollowed');
      window.location.reload();
    } else if (unfollow?.error) {
      alert('Error unfollowing user');
    } else if (follow?.error) {
      alert('Error following user');
    } else if (userDetails?.id && accountDetails?.id) {
      getPosts.request({
        profileId: `${userDetails?.id}`,
        publicationTypes: ['POST'],
      });

      getFollowing.request(`${userDetails?.ownedBy}`);
      getFollowers.request(`${userDetails?.id}`);
      doesFollow.request({
        followerAddress: accountDetails?.ownedBy,
        profileId: userDetails?.id,
      });
    }
    if (getProfile.data?.profiles?.items && !userDetails) {
      navigate('/404');
    }
  }, [
    userDetails?.id,
    accountDetails?.id,
    follow?.success,
    unfollow?.success,
    follow?.error,
    unfollow?.error,
  ]);

  // const submitHandler = async () => {
  //   createProfile.request({ handle: username });
  //   console.log('CREATE DATA', createProfile.data);
  // };

  let posts = [];
  console.log(accountDetails);
  console.log(
    'USER PUBLICATIONS HERE OOOO',
    getPosts.data?.publications?.items
  );
  let userPosts = getPosts.data?.publications?.items;

  let followers = getFollowers.data?.followers?.items;
  let following = getFollowing.data?.following?.items;

  console.log('THIS USER IS  FOLLOWING', following);
  console.log('THIS USER IS  BRING FOLLOWED BY', followers);

  let follows = doesFollow.data?.doesFollow?.[0]?.follows;
  console.log('DOES USER FOLLOW', follows);

  return (
    <StyledProfile
      exit="exit"
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      theme_={theme}
    >
      {!userDetails ? (
        <PageLoader visible={true} />
      ) : (
        <>
          <div className="left">
            <div className="body">
              <div className="header">
                <span
                  onClick={() => navigate(`${location?.state?.path || '/'}`)}
                  className="back"
                >
                  <KeyboardBackspaceIcon />
                </span>
                <span>
                  <h3>Profile</h3>
                </span>
              </div>
              <div className="photo-cont">
                <img
                  src={userDetails?.coverPicture?.original?.url || defPic}
                  className="cover"
                  alt="img"
                />
                <span className="dp">
                  <img
                    src={userDetails?.picture?.original?.url || defPic}
                    className="cover"
                    alt="img"
                  />
                </span>
              </div>
              <div className="details">
                {userDetails?.handle && <h2>@{userDetails?.handle}</h2>}
                {userDetails?.name && <h2>{userDetails?.name}</h2>}
                {userDetails?.location && (
                  <span className="with-icon">
                    {' '}
                    <LocationOnIcon /> <h2>{userDetails?.location}</h2>
                  </span>
                )}
                {userDetails?.website && (
                  <span className="with-icon">
                    <LinkIcon />
                    <h2>{userDetails?.website}</h2>
                  </span>
                )}
                {userDetails?.twitterUrl && (
                  <span className="with-icon">
                    <TwitterIcon />
                    <h2>{userDetails?.twitterUrl}</h2>
                  </span>
                )}
                <span className="bio">
                  <h3>{userDetails?.bio}</h3>
                </span>
                <span className="follow-stats">
                  <button
                    className="plain-btn"
                    onClick={() => setFollowersModal(true)}
                  >
                    {userDetails?.stats?.totalFollowers} Followers
                  </button>{' '}
                  |{' '}
                  <button
                    className="plain-btn"
                    onClick={() => setFollowingModal(true)}
                  >
                    {userDetails?.stats?.totalFollowing} Following
                  </button>
                </span>
                {accountDetails?.handle == userDetails?.handle && (
                  <button onClick={() => setProfileModal(true)}>
                    Edit Profile
                  </button>
                )}
                {accountDetails &&
                  accountDetails?.handle !== userDetails?.handle &&
                  (follows ? (
                    <button onClick={unfollowHandler}>
                      {unfollow?.loading ? 'Loading...' : 'UnFollow'}
                    </button>
                  ) : (
                    <button onClick={followHandler}>
                      {follow?.loading ? 'Loading...' : 'Follow'}
                    </button>
                  ))}
              </div>

              <span className="tabs">
                {tabs.map((tab, index) => (
                  <span
                    className={`tab ${activeTab === tab && 'active'}`}
                    key="index"
                    onClick={() => setActiveTab(tab)}
                  >
                    {tab}
                    <div className="line"></div>
                  </span>
                ))}
              </span>

              {activeTab === 'Posts' &&
                (userPosts?.length > 0 ? (
                  <div className="posts">
                    {userPosts?.map((post, index) => {
                      return (
                        post.__typename === 'Post' && (
                          <Post post={post} key={index} />
                        )
                      );
                    })}
                  </div>
                ) : (
                  <span className="no-posts">
                    <h2>User has no Post</h2>
                  </span>
                ))}
            </div>
          </div>
          <div className="right">
            <div className="body">
              <RecommendedUsers />
            </div>
          </div>

          <EditProfileModal
            show={profileModal}
            onClose={() => setProfileModal(false)}
            user={userDetails}
          />
          <FollowModal
            users={following}
            title="Following"
            show={followingModal}
            onClose={() => setFollowingModal(false)}
          />
          <FollowModal
            users={followers}
            title="Followers"
            show={followersModal}
            onClose={() => setFollowersModal(false)}
          />
        </>
      )}
    </StyledProfile>
  );
}
const StyledProfile = styled(motion.div)`
  display: flex;
  flex-flow: row wrap;

  width: 100%;
  min-height: 80vh;
  width: 100%;
  background: ${({ theme_ }) =>
    theme_ ? 'rgb(23, 24, 24,0.9)' : 'rgb(248, 248, 248,0.9)'};
  @media screen and (max-width: 900px) {
    position: absolute;
    width: 100%;
    padding-bottom: 15%;
  }
  padding: 2rem;
  .left {
    width: 59%;
    display: flex;
    flex-flow: column wrap;
    h3 {
      font-size: 1.3rem;
      font-weight: 500;
    }
    .body {
      -moz-box-shadow: 0 0 3px #ccc;
      -webkit-box-shadow: 0 0 3px #ccc;
      box-shadow: 0 0 3px #ccc;
      border-radius: 1rem;
      overflow: hidden;
      background: ${({ theme_ }) => (theme_ ? '#0f0f0f' : '#ffffff')};
    }
    h3 {
      font-size: 1.3rem;
      font-weight: 500;
    }
    .body {
      -moz-box-shadow: 0 0 3px #ccc;
      -webkit-box-shadow: 0 0 3px #ccc;
      box-shadow: 0 0 3px #ccc;
      border-radius: 1rem;
      overflow: hidden;
      background: ${({ theme_ }) => (theme_ ? '#0f0f0f' : '#ffffff')};
    }
    @media screen and (max-width: 900px) {
      width: 100%;
    }
    .header {
      display: flex;
      gap: 1rem;
      align-items: center;
      position: sticky;
      top: 0;
      padding: 1rem 2rem;
      background: ${({ theme_ }) =>
        theme_ ? 'rgb(15, 15, 15,0.8)' : 'rgb(255, 255, 255,0.8)'};
      .back {
        cursor: pointer;
      }
      z-index: 2;
      @media screen and (max-width: 900px) {
        display: flex;
        gap: 1rem;
        align-items: center;
        padding: 0.8rem 1rem;
      }
    }
    .photo-cont {
      height: 13rem;
      position: relative;
      margin-bottom: 4.5rem;
      .cover {
        display: block;
        object-fit: cover;
        height: 100%;
        width: 100%;
      }

      .dp {
        position: absolute;
        bottom: -28%;
        left: 50%;
        transform: translateX(-50%);
        width: 8.5rem;
        height: 8.5rem;
        border-radius: 50%;
        border: 5px solid ${({ theme_ }) => (theme_ ? '#0f0f0f' : '#ffffff')};
        overflow: hidden;
        display: flex;

        cursor: pointer;
        background: ${({ theme_ }) =>
          theme_ ? 'rgb(15, 15, 15,1)' : 'rgb(255, 255, 255,1)'};
        img {
          width: 100%;
          object-fit: cover;
          display: block;
        }
        .edit {
          display: none;
          color: white;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 2rem;
        }
        &:hover {
          img {
            opacity: 0.8;
          }

          .edit {
            display: block;
          }
        }
      }
    }

    img {
      display: block;
      width: 100%;
    }
    .details {
      display: flex;
      flex-flow: column wrap;
      gap: 0.7rem;
      align-items: center;
      padding-bottom: 2rem;
      h2 {
        font-size: 1.3rem;
        font-weight: 500;
      }
      .with-icon {
        display: flex;
        align-items: center;
        gap: 0.1rem;
      }
      .bio {
        padding: 0rem 2rem;
      }
      .follow-stats {
        display: flex;
        align-items: center;
        gap: 0.8rem;
      }
    }
  }

  .right {
    width: 40%;

    display: flex;
    flex-flow: column wrap;
    gap: 1rem;

    padding-left: 2rem;
    @media screen and (max-width: 900px) {
      display: none;
    }
  }
  .posts {
    display: flex;
    flex-flow: column wrap;
    gap: 0rem;
    padding: 0rem 0rem;
    width: 100%;
    @media screen and (max-width: 900px) {
      gap: 0rem;
      padding: 0rem 0rem;
      width: 100%;
    }
  }
  .no-posts {
    display: flex;
    justify-content: center;
    padding: 3rem 0rem;
  }
  .tabs {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;

    width: 100%;
    .tab {
      padding: 0rem 2rem;
      padding-top: 0.5rem;
      font-size: 1.2rem;
      cursor: pointer;
      &:hover {
        color: gray;
      }
      .line {
        margin-top: 0.5rem;
        padding: 2px;
        background: inherit;
        border-radius: 3rem 3rem 0px 0px;
      }
      &.active {
        .line {
          background: #76be02;
        }
      }
    }
  }
`;
